export default globalThis.$ip;